import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/progress';
// const REST_API_BASE_URL = '/api';

export const getAllProgress = () => axiosInstance.get(REST_API_BASE_URL);

export const getProgressById = (id) => axiosInstance.get(`${REST_API_BASE_URL}/${id}`);

export const createProgress = (progress) => axiosInstance.post(REST_API_BASE_URL, progress);

export const updateProgress = (id, progress) => axiosInstance.put(`${REST_API_BASE_URL}/${id}`, progress);

export const updateProgressStatus = (id, statusData) => {
    if (typeof statusData === 'string') {
        // Old way - just status as string
        return axiosInstance.put(`${REST_API_BASE_URL}/${id}/status`, { progressStatus: statusData });
    } else if (typeof statusData === 'object') {
        // New way - object with progressStatus and comments
        return axiosInstance.put(`${REST_API_BASE_URL}/${id}/status`, statusData);
    }
};

export const deleteProgress = (id) => axiosInstance.delete(`${REST_API_BASE_URL}/${id}`);

export const getProgressByStudentId = (studentId) => axiosInstance.get(`${REST_API_BASE_URL}/student/${studentId}`);

export const getProgressByStudyId = (studyId) =>
    axiosInstance.get(`${REST_API_BASE_URL}/study/${studyId}`); 

export const getTotalProgressCount = () => axiosInstance.get(`${REST_API_BASE_URL}/count`);

export const getLatest5ProgressByStudentId = (studentId) =>
    axiosInstance.get(`${REST_API_BASE_URL}/latest/5/${studentId}`);

export const getProgressByProgressDate = (progressDate) => axiosInstance.get(`${REST_API_BASE_URL}/progressDate`, { params: { progressDate } });

export const getProgressByStudyCompletion = (studyComplition) => axiosInstance.get(`${REST_API_BASE_URL}/studyComplition`, { params: { studyComplition } });

export const getProgressBySubmitThesis = (submitThesis) => axiosInstance.get(`${REST_API_BASE_URL}/submitThesis`, { params: { submitThesis } });

export const getProgressByMeetSupervisor = (meetSupervisor) => axiosInstance.get(`${REST_API_BASE_URL}/meetSupervisor`, { params: { meetSupervisor } });

export const getProgressBySupervisorResponse = (supervisorResponse) => axiosInstance.get(`${REST_API_BASE_URL}/supervisorResponse`, { params: { supervisorResponse } });

export const getProgressCountByStudentId = (studentId) =>
    axiosInstance.get(`${REST_API_BASE_URL}/count/student/${studentId}`);

// upload file

export const uploadProgressFile = async (id, file) => {
    const formData = new FormData();
    formData.append("file", file);

    return await axiosInstance.post(`${REST_API_BASE_URL}/${id}/upload`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

// Get file (for display)
export const getProgressFile = (filename) => {
    // const BACKEND_URL = "http://localhost:8285";
    const BACKEND_URL = "https://hetras.azuutoursandtravel.com/api";
    return `${BACKEND_URL}/progress/file/${filename}`;
};
